/**
 * Brazilian Portuguese (pt-BR) mappings for TopChatBanner
 * Simple key-value pairs for easy maintenance
 */

export const topChatBannerPtBR = {
  // Button labels
  "AI Toolkit": "Kit de IA",
  "Pick Slip": "Bilhete",
  "Game Explorer": "Explorador de Jogos",
  
  // Response modes
  "Standard": "Padrão",
  "Quick": "Rápido", 
  "Detailed": "Detalhado",
  
  // Version
  "v2": "v2",
  
  // Pick slip counter - we'll handle the number dynamically
  "picks": "apostas",
  
  // AI Prediction button
  "AI Prediction": "Previsão IA",
  "spin": "giro",
  "spins": "giros"
};